import { useEffect, useRef, useState } from "react";
import { Play } from "lucide-react";
import { img } from "@/lib/api";

const still = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export const ReelVideo = ({ src, poster, active = true, testid }) => {
  const ref = useRef(null), [seen, setSeen] = useState(false), [on, setOn] = useState(false);
  useEffect(() => {
    if (still || !ref.current) return;
    const io = new IntersectionObserver(([e]) => setSeen(e.isIntersecting), { threshold: 0.5 });
    io.observe(ref.current);
    return () => io.disconnect();
  }, []);
  useEffect(() => { const v = ref.current; if (!v) return; if (seen && active) v.play().catch(() => {}); else v.pause(); }, [seen, active]);
  return (
    <>
      <video ref={ref} src={seen || on ? img(src) : undefined} poster={poster ? img(poster) : undefined} muted loop playsInline preload="none" onPlaying={() => setOn(true)}
        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${on && active ? "opacity-100" : "opacity-0"}`} data-testid={testid} aria-hidden="true" />
      <span className={`absolute bottom-3 right-3 glass text-[10px] eyebrow px-2.5 py-1.5 flex items-center gap-1 transition-opacity ${active ? "opacity-100" : "opacity-0"}`}><Play className="w-3 h-3 fill-current" /> Reel</span>
    </>
  );
};
